  <template>
    <div>
      <base-header class="pb-6 pb-1 pt-5 pt-md-8 bg-gradient-custom" type="custom">
        <b-card>
          <form>
            <b-row class="form-group">
              <b-col xl="3" md="6">
              <!--  <base-input label="Plan">
                  <select class="form-control" v-model="selectedPlan">
                    <option
                      v-for="plan in planOptions"
                      :key="plan.ID_PLAN"
                      :value="plan.ID_PLAN"
                    >
                      {{ plan.ANUAL_MENSUAL }}
                    </option>
                  </select>
                </base-input>
                -->
                  <base-input label="Plan"  v-model="Plan" placeholder="Plan" ></base-input>
              </b-col>
              <b-col xl="3" md="6">
                <base-input label="Organización">
                  <select class="form-control" v-model="selectedOrg">
                    <option
                      v-for="org in orgOptions"
                      :key="org.ID_ORG"
                      :value="org.ID_ORG"
                    >
                      {{ org.NAME_ORG }}
                    </option>
                  </select>
                </base-input>
              </b-col>
              <b-col xl="3" md="6">
                <base-input
                  v-model="fechaActivacion"
                  label="Fecha Activacion"
                  type="datetime-local"
                  id="fechaActivacion"
                >
                </base-input>
              </b-col>

              <b-col xl="3" md="10">
                <b-row>
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <base-button  @click="editarSims" icon type="primary">
                    <span class="btn-inner--text">Asignar</span>
                  </base-button>
                </div>
              </b-row>
              <b-row >
                <div class="d-flex gap-2 justify-content-center">
                  <base-button  @click="regresarDashboard" icon type="warning">
                    <span class="btn-inner--icon"
                    ></span>
                    <span class="btn-inner--text">Cancelar</span>
                  </base-button>
                </div>
              </b-row>
              </b-col>


            </b-row>
          </form>
        </b-card>
      </base-header>
      <b-container fluid class="mt--4">
        <ReusableTable
          :key="tableKey"
          :title="tableTitle"
          :data="dataSims"
          :columns="columns"
          :per-page="itemsPerPage"
          :total="totalSims"
          :search-query="searchQuery"
          :show-checkbox="true"
          :showCheckboxButton="true"
          @fetch-data="cargarDatosSims"
          @search="onSearch"
          @page-change="onPageChange"
          @checkbox-change="handleSelectedRowsChange"
        >
          <tempale slot="filter">
            <button-checkbox :buttonClasses="'btn btn-outline-primary'">
              No asignados
            </button-checkbox>
          </tempale>
          <template
            v-for="columna in columns"
            v-slot:[`column-${columna.prop}`]="{ row }"
          >
            <span :key="columna.prop">
              <span v-if="columna.esAttData">{{
                obtenerValor(row, columna.prop)
              }}</span>
              <span v-else-if="columna.prop === 'DATA'">{{
                convertirUnidades(row[columna.prop])
              }}</span>
              <span
                v-else-if="
                  columna.prop === 'FECHA_VENCIMIENTO' ||
                  columna.prop === 'FECHA_ACTIVACION' ||
                  columna.prop === 'FECHA_CARGA_DATA'
                "
              >
                {{ formatearFechaParaDatetimeLocal(new Date(row[columna.prop])) }}
              </span>
              <span v-else>{{ row[columna.prop] }}</span>
            </span>
          </template>
        </ReusableTable>
      </b-container>

      <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal> 
    </div>
  </template>

  <script>
  import ReusableTable from "./Tables/RegularTables/TablaReu.vue";
  import axios from "axios";
  import BaseInput from "../components/Inputs/BaseInput.vue";
  import BaseButton from "../components/BaseButton.vue";
  import ButtonCheckbox from "../components/ButtonCheckbox.vue";
import TokenExpiredModal from '../components/TokenExpiredModal.vue';

  export default {
    components: { ReusableTable, BaseInput, BaseButton, ButtonCheckbox, TokenExpiredModal },
    data() {
      return {
        isLoading: false,
        selectedRows: [],
        dataSims: [],
        orgOptions: [],
        planOptions: [],
        selectedOrg: null,
        Plan: '',
        fechaActivacion: null,
        simStatus: null,
        showTokenExpiredModal: false,
        tableKey: 0, // Clave única
        currentPage: 1,
        itemsPerPage: 10,
        totalSims: 0,
        searchQuery: "",
        tableTitle: "Listado de Sims",
        columns: [
          { prop: "ICCID", label: "ICCID", minWidth: "210" },
          { prop: "PLAN", label: "Plan", minWidth: "120" },
          { prop: "NAME_ORG", label: "Nombre Org", minWidth: "150" },
          { prop: "LABEL", label: "LABEL", minWidth: "128" },
          { prop: "PRIMARY_MSISDN", label: "MSISDN", minWidth: "180" },
          { prop: "SIM_STATUS", label: "Estado SIM", minWidth: "150" },
          { prop: "DATA_STATUS", label: "Estado Datos", minWidth: "125" },
          { prop: "DATA", label: "Datos", minWidth: "140" },
          {
            prop: "FECHA_ACTIVACION",
            label: "Fecha Activación",
            minWidth: "200",
          },
          {
            prop: "FECHA_CARGA_DATA",
            label: "Fecha Carga Datos",
            minWidth: "200",
          },
          {
            prop: "Session_Status",
            label: "Estado Sesión",
            minWidth: "120",
            esAttData: true,
          },
          { prop: "Sms_Mo", label: "SMS MO", minWidth: "140", esAttData: true },
          { prop: "Sms_Mt", label: "SMS MT", minWidth: "140", esAttData: true },
          { prop: "Country", label: "País", minWidth: "140", esAttData: true },
          { prop: "Network", label: "Red", minWidth: "130", esAttData: true },
          { prop: "Tags", label: "Tags", minWidth: "100", esAttData: true },
          {
            prop: "Ip_Address",
            label: "Dirección IP",
            minWidth: "160",
            esAttData: true,
          },
          {
            prop: "Device_Imei",
            label: "IMEI Dispositivo",
            minWidth: "180",
            esAttData: true,
          },
        ],
      };
    },
    async mounted() {
      await Promise.all([
        this.cargarDatosSims(),
        this.fetchOrgOptions(),
        this.fetchPlanOptions(),
      ]);
    },
    watch: {
      currentPage() {
        this.cargarDatosSims();
      },
      searchQuery() {
        this.currentPage = 1;
        this.cargarDatosSims();
      },
    },
    methods: {
      handleSelectedRowsChange(selectedRows) {
        console.log("Filas seleccionadas:", selectedRows);
        this.selectedRows = selectedRows;
      },

      async mostrarFilasSeleccionadas() {
        console.log("Datos de las filas seleccionadas", this.selectedRows);
      },
      async editarSims() {
        // Validar que se hayan seleccionado SIMs
        if (this.selectedRows.length === 0) {
          this.$notifications.addNotification({
            type: "danger",
            message: "No se seleccionaron SIMs para actualizar.",
          });
          return;
        }

        const token = localStorage.getItem("token");
        this.isLoading = true;

        try {
          // Enviar la solicitud al backend
          const response = await axios.put(
            `${process.env.VUE_APP_API_URL}/editar-sims`,
            {
              ids: this.selectedRows, // Array de IDs
              idPlan: this.Plan, // ID del plan seleccionado
              idOrg: this.selectedOrg, // ID de la organización seleccionada
              fechaActivacion: this.fechaActivacion,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          // Manejar la respuesta del backend
          if (response.data.success) {
            this.$notifications.addNotification({
              type: "success",
              message: response.data.message,
            });
            // Recargar los datos de las SIMs
            this.cargarDatosSims();
            this.selectedOrg = null;
            this.Plan = "";
            this.fechaActivacion = null;
            this.selectedRows = [];
            this.$router.push({name: "dashboard"}); // Redirigir a la página de SIMs
            // Forzar la actualización del componente
            this.tableKey += 1; // Cambiar la clave única
          } else {
            this.$notifications.addNotification({
              type: "danger",
              message: response.data.message || "Error al actualizar SIMs.",
            });
          }
        } catch (error) {
          console.error("Error en la solicitud:", error);
          if (error.response) {
            // Mostrar el mensaje de error del backend
            this.$notifications.addNotification({
              type: "danger",
              message: error.response.data.message || "Error en la solicitud.",
            });
          } else {
            this.$notifications.addNotification({
              type: "danger",
              message: "Error en la solicitud. Verifica la conexión.",
            });
          }
        } finally {
          this.isLoading = false;
        }
      },
      async fetchOrgOptions() {
        await this.fetchOptions(
          "obtenerTodasLasOrgs",
          "orgOptions",
          "organizaciones"
        );
      },
      async fetchPlanOptions() {
        await this.fetchOptions("obtenerTodosLosPlanes", "planOptions", "planes");
      },
      async fetchOptions(endpoint, dataProperty, errorMessage) {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            this.handleTokenExpired();
            return;
          }

          const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/${endpoint}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (response.data.success) {
            this[dataProperty] = response.data.data;
          } else {
            this.handleError(
              response.data.message || `Error al cargar ${errorMessage}`
            );
          }
        } catch (error) {
          this.handleError(
            `Error al cargar ${errorMessage}. Verifica la conexión.`,
            error
          );
        }
      },
      async cargarDatosSims({ page, perPage, search, mostrarNoAsignados } = {}) {
  const token = localStorage.getItem("token");

  if (!token) {
    this.handleTokenExpired();
    return;
  }

  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL}/leerDatosSIM`,
      {
        params: {
          page: page || this.currentPage,
          perPage: perPage || this.itemsPerPage,
          search: search || this.searchQuery,
          mostrarNoAsignados: mostrarNoAsignados || this.mostrarNoAsignados, // Agregar mostrarNoAsignados
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success) {
      this.dataSims = Array.isArray(response.data.datos)
        ? response.data.datos
        : [];
      this.totalSims = response.data.total || 0;
    } else {
      this.handleError("Error al cargar los SIMs.");
      this.dataSims = [];
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      this.handleTokenExpired();
    } else {
      this.handleError("Error en la solicitud:", error);
    }
    this.dataSims = [];
  }
},
onMostrarNoAsignadosChange(value) {
    this.mostrarNoAsignados = value;
    this.currentPage = 1; // Resetear la página
    this.cargarDatosSims();
  },
      onSearch(searchQuery) {
        this.searchQuery = searchQuery;
        this.cargarDatosSims();
      },
      onPageChange(page) {
        this.currentPage = page;
        this.cargarDatosSims();
      },
      handleTokenExpired() {
        this.showTokenExpiredModal = true;
        setTimeout(() => {
          this.$router.push("/login");
          localStorage.removeItem("token");
        }, 3000);
      },
      regresarDashboard(){
        this.$router.push({name: "dashboard"});
      },
      obtenerValor(objeto, ruta) {
        try {
          const attDataObject = JSON.parse(objeto.ATT_DATA);
          return attDataObject[ruta];
        } catch (error) {
          console.error("Error al obtener valor:", error);
          return "";
        }
      },
      convertirUnidades(valor) {
        const val = parseFloat(valor);
        const units = [
          { value: 1000000000, suffix: "GB" },
          { value: 1000000, suffix: "MB" },
          { value: 1000, suffix: "KB" },
          { value: 1, suffix: "bits" },
        ];

        const unit = units.find((u) => val >= u.value);
        return unit
          ? `${(val / unit.value).toFixed(2)} ${unit.suffix}`
          : "0 bits";
      },
      formatearFechaParaDatetimeLocal(fecha) {
        return fecha.toISOString().slice(0, 16);
      },
      handleError(message, error) {
        console.error(message, error);
        alert(`Error: ${message}`);
      },
    },
  };
  </script>
